export const streamPlatforms = ["none", "YT", "Twitch", "both"] as const;
export type StreamPlatform = (typeof streamPlatforms)[number];

export type SinglePlatform = "YT" | "Twitch";
export const singlePlatforms: readonly SinglePlatform[] = ["YT", "Twitch"];

export function hasPlatform(
  selection: StreamPlatform,
  platform: SinglePlatform,
) {
  const isBoth = selection === "both";
  if (isBoth) return true;
  return selection === platform;
}

export function togglePlatform(
  selection: StreamPlatform,
  platform: SinglePlatform,
) {
  const hasYouTube = hasPlatform(selection, "YT");
  const hasTwitch = hasPlatform(selection, "Twitch");
  const nextYouTube = platform === "YT" ? !hasYouTube : hasYouTube;
  const nextTwitch = platform === "Twitch" ? !hasTwitch : hasTwitch;
  return combinePlatforms(nextYouTube, nextTwitch);
}

function combinePlatforms(youtube: boolean, twitch: boolean): StreamPlatform {
  const isBoth = youtube && twitch;
  if (isBoth) return "both";
  if (youtube) return "YT";
  if (twitch) return "Twitch";
  return "none";
}

export function selectedPlatforms(selection: StreamPlatform) {
  const isSelected = (platform: SinglePlatform) =>
    hasPlatform(selection, platform);
  return singlePlatforms.filter(isSelected);
}

export function platformName(platform: SinglePlatform) {
  const isYouTube = platform === "YT";
  return isYouTube ? "YouTube" : "Twitch";
}

export function toggleSlotPlatform(
  slot: { platform: StreamPlatform; memberOnly?: boolean },
  platform: SinglePlatform,
) {
  if (platform === "Twitch") {
    return { platform: togglePlatform(slot.platform, platform) };
  }
  const selected = hasPlatform(slot.platform, platform);
  if (selected && !slot.memberOnly) {
    return { platform: slot.platform, memberOnly: true };
  }
  const nextPlatform = togglePlatform(slot.platform, platform);
  const memberOnly = hasPlatform(nextPlatform, "YT") && Boolean(slot.memberOnly);
  return { platform: nextPlatform, memberOnly };
}
